import { useEffect } from "react";
import { PRICING_PAGE } from "@/lib/constants";
import PricingCard from "@/components/sections/pricing/PricingCard";
import UsagePricing from "@/components/sections/pricing/UsagePricing";
import ValueComparison from "@/components/sections/pricing/ValueComparison";
import CompetitorComparison from "@/components/sections/pricing/CompetitorComparison";
import ProfessionalSetup from "@/components/sections/pricing/ProfessionalSetup";
import PricingFAQ from "@/components/sections/pricing/PricingFAQ";
import Guarantee from "@/components/sections/pricing/Guarantee";
import PricingCTA from "@/components/sections/pricing/PricingCTA";

export default function PricingPage() {
  const { hero } = PRICING_PAGE;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="pricing-page">
      {/* Hero */}
      <section
        data-testid="pricing-hero"
        className="bg-white pt-24 md:pt-32 pb-12 md:pb-16"
        aria-label="Pricing page hero"
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl text-center">
          <h1
            data-testid="pricing-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A1A1A] leading-tight tracking-tight mb-6"
          >
            {hero.headline}
          </h1>
          <p className="text-base md:text-lg text-[#6B7280] leading-relaxed max-w-2xl mx-auto">
            {hero.subheadline}
          </p>
        </div>
      </section>

      <PricingCard />
      <UsagePricing />
      <ValueComparison />
      <CompetitorComparison />
      <ProfessionalSetup />
      <PricingFAQ />
      <Guarantee />
      <PricingCTA />
    </div>
  );
}
